import * as d3 from 'd3'
export default {

  methods: {

    draw_Status() {

      let bar = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.status.x + .5}, ${this.status.y + .5})`)

      let barLen = (this.status.width/100) * this.rawData.PROG
      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', this.status.bar.radius)
      .attr('width', this.status.width).attr('height', 8)
      .attr('fill', this.columns.find(f=> f.code == 'REMAIN').bColor).attr('stroke-width', 0)
      .attr('opacity', .5)

      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', this.status.bar.radius)
      .attr('width', barLen).attr('height', 8)
      .attr('fill', this.columns.find(f=> f.code == 'ACTUAL').bColor).attr('stroke-width', 0)

      bar // Prog
      .append('text')
      .attr('id', `PROG_${this.localId}`)
      .attr('x', 0).attr('y', -12)
      .attr('fill', this.status.prog.tColor).attr('font-size', this.status.prog.tSize)
      .attr('text-anchor', 'start')
      .text(this.rawData.PROG)

      bar // Unit
      .append('text')
      .attr('x', this.getNode(`#PROG_${this.localId}`) + 2).attr('y', -12)
      .attr('fill', this.status.unit.tColor).attr('font-size', this.status.unit.tSize)
      .attr('text-anchor', 'start')
      .text(this.status.unit.value)

      bar // Prog
      .append('text')
      .attr('x', 2).attr('y', -3)
      .attr('fill', '#757575').attr('font-size', 8)
      .attr('text-anchor', 'start')
      .text('Progress(%)')


      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.status.x + .5}, ${this.status.y + .5 - this.status.height})`)

      this.columns.forEach(col=> {
        if(col.code == 'PROG') return

        status // Name
        .append('text')
        .attr('x', col.ex).attr('y', this.status.name.tSize*0.75)
        .attr('fill', this.status.name.tColor).attr('font-size', this.status.name.tSize)
        .attr('text-anchor', 'end')
        .text(col.name)

        status // Value
        .append('text')
        .attr('x', col.ex).attr('y', this.status.value.y + this.status.value.tSize*0.75)
        .attr('fill', this.status.value.tColor).attr('font-size', this.status.value.tSize)
        .attr('text-anchor', 'end')
        .text(this.rawData[col.code])
        .call(this.event_Link, col)

      })

    },

  } 
}